
var lib_geometry = require("lib-geometry");
var textTracer = require("./../svg/fonts/textTracer.js");

var TextMeshHelper = function(textData, holes, height, segments, text){
    var mesh = (new lib_geometry.TriangleMesh()); 

    textData.getTracesAsPCB(text).forEach(function(trace){
        var poly = trace.toOutlineGeometry(parseFloat(trace.width), segments);
        poly = poly.translate(textData.pos());
        poly = poly.rotate(textData.angle(), textData.pos());
        if(textData.keepReadable && textData.keepReadable() && textData.angle() > 90 && textData.angle() <= 270){
            var center = textData.boundingBox().getCenter();
            poly = poly.rotate(180, center);
        }
        
        var cutGeom = lib_geometry.Union([poly], holes);
        var thismesh = (new lib_geometry.TriangleMesh()).fromPolygon(cutGeom, height);
        mesh.mergeMesh(thismesh);
    });

    return mesh;
}
 

module.exports = TextMeshHelper;